import { connect } from 'react-redux';
import reduxForm from 'redux-form/lib/reduxForm';
import {
  showCreateAccount,
  showRequestResetPassword,
  submitLogInForm,
} from '../../user';
import { Login } from '../Login';

const mapDispatchToProps = (dispatch, ownProps) => {
  const { loginCallback } = ownProps;
  return {
    onSubmit: data => dispatch(submitLogInForm(data, loginCallback)),
    clickCreateAccount: () => dispatch(showCreateAccount('Create Account')),
    clickRequestResetPassword: () =>
      dispatch(showRequestResetPassword('Forgot Password')),
  };
};

const mapStateToProps = ({}, { feedUrl }) => ({
  feedUrl,
});

const LoginContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'login',
  })(Login)
);

export { LoginContainer };
